import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { RootState } from "../../redux/index";
import API from "../../vendor/api";

import MainSidebar from "./Main";
import EditProfile from "./EditProfile";
import Profile from "./Profile";

const s = require("./sidebar.scss");

interface ISidebarProps {
    user: API.User;
    activeView: string;
    dispatch?: Dispatch<any>;
};

interface ISidebarState {};

class Sidebar extends React.Component<ISidebarProps, ISidebarState> {

    public render(): JSX.Element {       
        const sidebar = () => {
            switch (this.props.activeView) {
                case "chatList":
                case "contactList":
                    return <MainSidebar/>;
                case "editMyProfile":
                    return <EditProfile/>;
                case "profile":
                    return <Profile/>;
            }
        };


        return sidebar();
    }
}

export default connect((state: RootState) => ({
    user: state.auth.user,
    activeView: state.ui.sidebar.view
}))(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/Sidebar/index.tsx